<template>
  <GdprModal />
</template>

<script setup lang="ts">
import GdprModal from './GdprModal.vue';
</script>
